module.exports = __webpack_public_path__ + "static/media/16UNODC10.7cb93c9b.jpg";